module.exports = __webpack_public_path__ + "static/img/game-ud.6406ee0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-ud.jpg
// module id = SN66
// module chunks = 0